import Tilt from 'react-parallax-tilt';
import './tiltImage.css';


const TiltImg = ({ img, h, w }) => (
  <Tilt
    tiltMaxAngleX={35}
    tiltMaxAngleY={35}
    perspective={900}
    scale={1.05}
    transitionSpeed={2000}
    gyroscope={true}
    style={{
      width: w,
      height: h,
      overflow: "hidden",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#000",
    }}
  >
    <img
      src={img}
      alt="Tilted"
      style={{
        maxWidth: "100%",
        maxHeight: "100%",
        width: "auto",
        height: "auto",
        objectFit: "contain",
        display: "block",
      }}
    />
  </Tilt>
);


export default TiltImg;